if (!customElements.get('collections-banner')) {
  customElements.define(
    'collections-banner',
    class CollectionsBanner extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const { scrollX, scrollY } = window;
        const activeCollection = this.querySelector('.active-collection');
        if (activeCollection) {
          activeCollection.scrollIntoView({behavior: "smooth", inline: 'center', container: 'nearest'});
        }
        window.scrollTo({
          top: scrollY,
          left: scrollX,
          behavior: "instant",
        });
      }
    }
  );
}
